import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-filter-basic',
  template: `
    <form [formGroup]="filterForm">
      <div class="row mt-5">
        <div class="col-md-3">
          <!-- h2 class="mb-0">Habitacionales</h2> {{ufc['settlement_id'].value}} -->
          <select class="form-select form-select-lg rounded-5 border border-2 bg-transparent" formControlName="settlement_id" (change)="selectSettlement($event)">
            <option selected [selected]="true">Condominio</option>
            <option *ngFor="let settlement of settlements" [value]="settlement.id" >{{settlement.name}}</option>
          </select>
        </div>
        <div class="col-md-2">
          <select class="form-select form-select-lg rounded-5 border border-2 bg-transparent" formControlName="building_id" (change)="selectBuilding($event)">
            <option selected [selected]="true" >Edificio</option>
            <option *ngFor="let building of buildings" [value]="building.id" >{{building.name}}</option>
          </select>
        </div>
        <div class="col-md-2">
          <select class="form-select form-select-lg rounded-5 border border-2 bg-transparent" (change)="selectFloor($event)">
            <option selected [selected]="true" >Piso</option>
            <option *ngFor="let floor of floors" [value]="floor.id" >{{floor.name}}</option>
          </select>
        </div>
        <div class="col-md-2">
          <select class="form-select form-select-lg rounded-5 border border-2 bg-transparent" (change)="selectUnit($event)">
            <option selected [selected]="true" >Depto.</option>
            <option *ngFor="let unit of units" [value]="unit.id" >{{unit.name}}</option>
          </select>
        </div>
        <!-- div class="col-md-3" *ngIf="!searchActive">
          <form [formGroup]="searchBox" (ngSubmit)="searchUsers($event)">
            <input class="form-control form-control-lg" placeholder="Buscar..." formControlName="search">
          </form>
        </!-->
        <div class="col-md-3 text-end" *ngIf="searchActive">
          <button class="btn btn-link text-danger mt-2" (click)="clearFilter()">
            <fa-icon [icon]="icons.faTimes" size="lg" animation="spin" class="me-3"></fa-icon>
            Limpiar filtros
          </button>
        </div>
      </div>
    </form>
  `,
  styleUrls: []
})
export class FilterBasicComponent {
  @Input() profile: any;
  @Output() billsSettlement = new EventEmitter<any>();
  @Output() billsBuilding = new EventEmitter<any>();
  @Output() billsFloor = new EventEmitter<any>();
  @Output() billsUnit = new EventEmitter<any>();
  @Output() clear = new EventEmitter<any>();

  loading: boolean = false;
  searchActive: boolean = false;

  settlements: any = [];
  buildings: any = [];
  floors: any = [];
  units: any = [];

  filterForm: FormGroup = new FormGroup({});

  constructor(
    private store: SettlementsService,
    private router: Router,
    private route: ActivatedRoute,
    public icons: IconsService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.loadSettlements();
    this.initForm();

    this.route.queryParamMap.subscribe(params => {
      const condominio = params.get('condominio');
      const edificio = params.get('edificio');
      console.log("condominio => ", condominio);
      /*if (condominio) {       
        let item: any = { target:  { value: '' }};
        item.target.value = condominio;

        this.filterForm.patchValue({ settlement_id: condominio });
        this.selectSettlement(item);
      }

      if (edificio) {
        let item: any = { target:  { value: '' }};
        item.target.value = edificio;

        this.filterForm.patchValue({ building_id: edificio });
        this.selectBuilding(item);
      }*/

      // Perform search logic based on query parameters
      // this.performSearch(searchQuery, category, minPrice, maxPrice);
    });
  }

  initForm() {
    this.filterForm = this.fb.group({
      settlement_id: [''],
      building_id: [''],
      // floor: [''],
      // unit: ['']
    });
  }

  loadSettlements() {
    let settlementPayload: any = {
      page: 1,
      per_page: 300,
      utility_id: this.profile.utility_id
    };
    this.store.getSettlements(settlementPayload).subscribe((data: any) => {
      this.settlements = data.data;
    });
  }
  
  selectSettlement(event: any) {
    let buildingPayload: any = {
      page: 1,
      per_page: 50,
      settlement_id: event.target.value
    };

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { "condominio": event.target.value },
      queryParamsHandling: 'merge'
    });
    
    this.store.getBuildings(buildingPayload).subscribe((data: any) => {
      this.buildings = data.data;
      this.searchActive = true;
    });

    this.billsSettlement.emit(event.target.value);
  }

  selectBuilding(event: any) {
    let unitPayload: any = {
      page: 1,
      per_page: 50,
      building_id: event.target.value
    };
    this.store.getFloors(unitPayload).subscribe((data: any) => {
      this.floors = data.data;
    });

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { "edificio": event.target.value },
      queryParamsHandling: 'merge'
    });

    this.billsBuilding.emit(event.target.value);
  }

  selectFloor(event: any) {
    let unitPayload: any = {
      page: 1,
      per_page: 50,
      floor_id: event.target.value
    };
    this.store.getUnits(unitPayload).subscribe((data: any) => {
      this.units = data.data;
      console.log("UNITS => ", data);
    });

    this.billsFloor.emit(event.target.value);
  }

  selectUnit(event: any) {
    let unitPayload: any = {};
    

    this.billsUnit.emit(event.target.value);
  }

  clearFilter() {
    const urlWithoutQueryParams = this.router.url.substring(0, this.router.url.indexOf('?'));
    this.router.navigateByUrl(urlWithoutQueryParams);
    this.settlements = [];
    this.loadSettlements();
    this.units = [];
    this.floors = [];
    this.buildings = [];
    this.searchActive = false;
    this.clear.emit();
  }

}
